import React from 'react';

export const Confetti = () => (
    <>
        <path d="M2 2H4M3 1V3M9.5 1L9 3M16 2H18M17 1V3M13 6L12 7M16 10L18 9.5M16 16H18M17 15V17M12 13.518L5.48205 7L1.09205 16.58C1.00528 16.766 0.977846 16.9742 1.01347 17.1763C1.0491 17.3785 1.14605 17.5647 1.29118 17.7099C1.43632 17.855 1.62259 17.952 1.82472 17.9876C2.02685 18.0232 2.23505 17.9958 2.42105 17.909L12 13.518Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
    </>
);